<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
                <font-awesome-icon class="md-icon" :icon="['fa', 'calendar']"/>
            </div>
            <h4 class="title">Planification</h4>
        </md-card-header>
        <md-card-content>
            <div v-if="intervention.status_id !== 1">
                <span class="font-bold">Date : </span>
                <span>{{ date }}</span>
            </div>
            <div v-else class="mb-3">
                <form>
                    <div class="flex items-center space-x-5">
                        <div class="w-2/4">
                            <div class="md-vdatepicker">
                                <datetime v-model="day" type="date" auto :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }">
                                    <label slot="before">Date</label>
                                </datetime>
                            </div>
                        </div>
                        <div class="w-1/4">
                            <div class="md-vdatepicker">
                                <datetime v-model="startTime" type="time" auto
                                          :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }" :minute-step="5">
                                    <label slot="before">Heure de début</label>
                                </datetime>
                            </div>
                        </div>
                        <div class="w-1/4">
                            <div class="md-vdatepicker">
                                <datetime v-model="endTime" type="time" auto
                                          :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }" :minute-step="5">
                                    <label slot="before">Heure de fin</label>
                                </datetime>
                            </div>
                        </div>
                    </div>
	                <div class="flex items-center space-x-4">
		                <div class="md-multiselect w-full">
			                <label>Technicien</label>
			                <multiselect v-model="technician"
			                             :options="technicians"
			                             :preserve-search="true"
			                             :show-labels="false"
			                             label="full_name"
			                             track-by="full_name"
			                             placeholder="Technicien">
				                <template slot="noOptions">La liste est vide</template>
				                <template slot="noResult">Aucun élement correspondant</template>
			                </multiselect>
		                </div>
		                <div class="md-multiselect w-full">
			                <label>Catégorie</label>
			                <multiselect v-model="category"
			                             :options="categories"
			                             :preserve-search="true"
			                             :show-labels="false"
			                             :disabled="intervention.category_id === 1"
			                             label="name"
			                             track-by="id"
			                             placeholder="Catégorie">
				                <template slot="noOptions">La liste est vide</template>
				                <template slot="noResult">Aucun élement correspondant</template>
			                </multiselect>
		                </div>
	                </div>

                    <div class="flex items-center space-x-5">
                        <md-button class="md-warning md-icon-button md-raised my-0" @click="updateIntervention">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                            <span class="leading-none ml-2 font-medium">Modifier</span>
                        </md-button>
                        <md-button class="md-success md-icon-button md-raised my-0" @click="validateIntervention">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'check-circle']" />
                            <span class="leading-none ml-2 font-medium">Valider l'intervention</span>
                        </md-button>
                    </div>
                </form>
            </div>
            <div>
                <span class="font-bold">État : </span>
                <span v-if="canUpdateStatus" class="text-info cursor-pointer hover:underline" @click="updateStatusIntervention">
                    {{ intervention.status.name }}
                </span>
                <span v-else>
                    {{ intervention.status.name }}
                </span>
            </div>
            <div>
                <span class="font-bold">Déprogrammer : </span>
                <template v-if="isDelayable">
                    <span class="text-info cursor-pointer" @click="returnToGestion">
                    Remettre en attente
                    </span>
                </template>
                <span v-else>Impossible à déprogrammer !</span>
            </div>
            <div>
                <span class="font-bold">Temps d'intervention prévu : </span>
                <span v-if="isPrevision">{{ intervention.planning_intervention_prevision.duration + 'm' }}</span>
                <span v-else>Pas de prévision</span>
            </div>
            <div>
                <span class="font-bold">Technicien : </span>
                <span>{{ intervention.technician.full_name }}</span>
            </div>
            <div class="flex items-center justify-between mt-2">
                <md-button class="md-info md-icon-button md-raised my-auto" @mousedown="goToCalendar($event)">
                    <font-awesome-icon class="md-icon" :icon="['fa', 'calendar']" />
                    <span class="leading-none ml-2 font-medium">Accéder au calendrier</span>
                </md-button>
	            <md-button v-if="intervention.status_id === 4" class="md-success md-icon-button md-raised my-auto"
	                       @click="closeIntervention">
		            <font-awesome-icon class="md-icon" :icon="['fa', 'check-circle']" />
		            <span class="leading-none ml-2 font-medium">Clôturer l'intervention</span>
	            </md-button>
            </div>
        </md-card-content>
    </md-card>
</template>

<script>
import dateTimeFormattingMixin from '../../../../../mixins/date-time-formatting-mixin';
import routerMixin from "../../../../../mixins/router-mixin";
export default {
    name: "Planification",
    props: {
        intervention: Object
    },
    mixins: [dateTimeFormattingMixin, routerMixin],
    data() {
        return {
            day: this.$moment(this.intervention.planningable.start_date).format(),
            startTime: this.$moment(this.intervention.planningable.start_date).format(),
            endTime: this.$moment(this.intervention.planningable.end_date).format(),
            technician: this.intervention.technician,
	        category: this.intervention.category,
            technicians: [],
	        categories: [],
        }
    },
    computed: {
        date() {
            const planningable = this.intervention.planningable
            const day = this.$moment(planningable.start_date).format('DD/MM/YYYY à HH:mm')
            const duration = this.durationBetweenDates(planningable.start_date, planningable.end_date)
            return `Le ${day} pour une durée de ${duration}`
        },
	    canUpdateStatus() {
			return ![1, 6].includes(this.intervention.status_id)
	    },
        isPrevision() {
            return !!this.intervention.planning_intervention_prevision
        },
        isDelayable() {
            return this.intervention.status_id === 1
        }
    },
    methods: {
        async updateStatusIntervention() {
	        const newStatusId = this.intervention.status_id === 1 ? 4 : 1

            try {
                await this.$store.dispatch('interventions/updateInterventionStatus', {
                    interventionId: this.intervention.id,
                    statusId: newStatusId
                })
                this.$emit('updated')

	            if(newStatusId === 1) {
		            await this.getTechnicians()

		            if(this.intervention.category_id !== 1) {
			            await this.getInterventionCategories()
		            }
	            }
            } catch (e) {}
        },
        async updateIntervention() {
            const startDate = this.$moment(this.day)
                .hours(parseInt(this.$moment(this.startTime).format('HH')))
                .minutes(parseInt(this.$moment(this.startTime).format('mm')))
                .format('YYYY-MM-DD HH:mm:ss')

            const endDate = this.$moment(this.day)
                .hours(parseInt(this.$moment(this.endTime).format('HH')))
                .minutes(parseInt(this.$moment(this.endTime).format('mm')))
                .format('YYYY-MM-DD HH:mm:ss')

            try {
                await this.$store.dispatch('interventions/updateInterventionInfosPlanning', {
                    interventionId: this.intervention.id,
                    start_date: startDate,
                    end_date: endDate,
                    technician_id: this.technician.id,
	                category_id: this.category.id
                })
                await this.$store.dispatch('alerts/success', 'Intervention modifiée')
                this.$emit('updated')
            } catch (e) {}
        },
        async validateIntervention() {
            try {
                await this.$store.dispatch('interventions/updateInterventionStatus', {
                    interventionId: this.intervention.id,
                    statusId: 4
                })
                this.$emit('updated')
            } catch (e) {}
        },
	    async closeIntervention() {
			try {
				await this.$store.dispatch('interventions/updateInterventionStatus', {
					interventionId: this.intervention.id,
					statusId: 6
				})
				await this.$store.dispatch('alerts/success', 'L\'intervention a bien été clôturée')
				this.$emit('updated')
			} catch (e) {}
	    },
        async returnToGestion() {
            try {
                await this.$store.dispatch('interventions/updateInterventionToGestion', {
                    interventionId: this.intervention.id
                })
                await this.$store.dispatch('alerts/success', 'Intervention remise en gestion')
                await this.$router.push({ name: 'Planning Management' })
            } catch (e) {}
        },
        async getTechnicians() {
            const { data } = await this.$store.dispatch('users/getTechnicians', { isActive: true, order: 'order' })
            this.technicians = data
        },
	    async getInterventionCategories() {
		    const { data } = await this.$store.dispatch('interventions/getInterventionCategories')
		    this.categories = data.filter(category => category.name !== 'Contrat')
	    },
	    goToCalendar(event) {
			this.goToRoute(event, 'Calendar', {}, {
				month: this.$moment(this.intervention.planningable.start_date).month(),
				year: this.$moment(this.intervention.planningable.start_date).year(),
				technicianId: this.intervention.user_id
			})
	    }
    },
    mounted() {
        if(this.intervention.status_id === 1) {
            this.getTechnicians()

	        if(this.intervention.category_id !== 1) {
		        this.getInterventionCategories()
	        }
        }
    }
}
</script>

<style scoped>

</style>
